/* Sticky navbar */

export function sticky_nav() {

	( ( $ ) => {

		let site_navigation_admin_height = $( '#wpadminbar' ).outerHeight() || 0;
		let site_navigation_original_position = $( '#site-navigation' ).offset().top - site_navigation_admin_height;

		const cov_reposition_sticky_menu = ( ev ) => {

			if ( 'resize' == ev.type ) {
				site_navigation_admin_height = $( '#wpadminbar' ).outerHeight() || 0;
				site_navigation_original_position = $( '#site-navigation' ).offset().top - site_navigation_admin_height;
				
				if ( $( '#wp-admin-bar-wp-logo' ).is( ':hidden' ) ) {
					$( '#site-navigation' ).css( 'margin-top', 0 );
					site_navigation_original_position = $( '#wpadminbar' ).outerHeight() + $( '.announcement-bar--top-bar' ).outerHeight();
				}
			}
		
			if ( $( ev.currentTarget ).scrollTop() >= site_navigation_original_position ) {
				$( '#site-navigation' ).addClass( 'fixed-top' ).css( 'margin-top', site_navigation_admin_height );

				let scroll_spacing = $( '#site-navigation' ).outerHeight();
				
				$( 'body' ).css( 'padding-top', scroll_spacing );
			} else {
				$( '#site-navigation' ).removeClass( 'fixed-top' ).css( 'margin-top', 0 );
				$( 'body' ).css( 'padding-top', 0 );
			}

			if ( $( '#wp-admin-bar-wp-logo' ).is( ':hidden' ) ) {
				$( '#site-navigation' ).css( 'margin-top', 0 );

				let scroll_spacing = $( '#wpadminbar' ).outerHeight() + $( '.announcement-bar--top-bar' ).outerHeight();

				if ( $( '#community-root-menu' ).length > 0 ) {
					scroll_spacing += $( '#community-root-menu' ).outerHeight();
				}

				site_navigation_original_position = scroll_spacing;
			}
		
			$( '.announcement-bar--top-bar .alert' ).on( 'closed.bs.alert', () => {
				site_navigation_original_position = 0;

				if ( $( '#wp-admin-bar-wp-logo' ).is( ':hidden' ) ) {
					site_navigation_original_position = $( '#wpadminbar' ).outerHeight();
				}
			} );

			// Storing the size as a global var so we can use it later
			window.COVE.navbar_total_height = 0;

			if ( $( '#wpadminbar' ).length > 0 ) {
				window.COVE.navbar_total_height += parseInt( $( '#wpadminbar' ).outerHeight() );
			}

			if ( $( '#site-navigation' ).length > 0 ) {
				window.COVE.navbar_total_height += parseInt( $( '#site-navigation' ).outerHeight() );
			}

			if ( $( '#community-root-menu' ).length > 0 ) {
				window.COVE.navbar_total_height += parseInt( $( '#community-root-menu' ).outerHeight() );
			}

		}

		$( window ).on( 'resize', cov_reposition_sticky_menu );
		$( window ).on( 'scroll', cov_reposition_sticky_menu );
		$( window ).on( 'cove:animation:hero', cov_reposition_sticky_menu );

		if ( $( '#community-root-menu-wrapper' ).length > 0 ) {
			$( '#community-root-menu-wrapper' ).on( 'shown.bs.collapse hidden.bs.collapse', ( ev ) => {
				site_navigation_original_position = $( '#community-root-menu' ).outerHeight() || 0 + $( '.announcement-bar--top-bar' ).outerHeight() || 0 - $( '#wpadminbar' ).outerHeight() || 0;
	
				cov_reposition_sticky_menu( {} );
			} );
		}

		// Trigger this dummy event on load, so everything runs for the first time.
		$( window ).trigger( 'resize' );

		// Prioritize the active state over menus that may share ancestors
		const prioritize_active_menu_links = () => {
			
			const main_menu = $( '#site-navigation' ).find( '#main-menu' );

			// Let's just apply all of this just to community pages, because
			// that's where the issue started.
			if ( main_menu.length <= 0 || $( '#community-root-menu' ).length <= 0 ) {
				return;
			}

			let to_activate_id = '';
			const classes_to_check = [ 'current-menu-item', 'current-menu-parent', 'current-menu-ancestor' ];

			// Get the first occurrence of the active status
			$.each( classes_to_check, ( index, classname ) => {
				if ( '' != to_activate_id ) {
					return false;
				}

				main_menu.find( '.navbar-nav > .menu-item' ).each( ( index2, element ) => {
					if ( $( element ).hasClass( classname ) ) {
						to_activate_id = $( element ).attr( 'id' );
						return false;
					}
				} );
			} );

			// Discard the active state in each element
			if ( '' != to_activate_id ) {
				main_menu.find( '.navbar-nav .menu-item' ).each( ( i, e ) => {
					$( e ).removeClass( [ 'current-menu-item', 'current-menu-ancestor', 'current-menu-parent' ] );
					$( e ).find( '> a' ).removeAttr( 'aria-current' );
					$( e ).find( '> a' ).removeClass( 'active' );
				} );

				main_menu.find( `#${to_activate_id}` ).addClass( 'current-menu-item' );
				main_menu.find( `#${to_activate_id} > a` ).addClass( 'active' );
				main_menu.find( `#${to_activate_id} > a` ).attr( 'aria-current', 'page' );
			}
		}

		// We solved in PHP. We'll use this one in case we need it
		// prioritize_active_menu_links();

	} )( window.jQuery );

}
